import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, HostBinding, NgModule, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { ORDER_ENTRIES_CONTEXT, OrderEntriesSource, ProductImportStatus } from '@spartacus/cart/base/root';
import { combineLatest, of, Subscription, Subject, BehaviorSubject } from 'rxjs';
import { take, map, switchMap, tap, startWith, filter, finalize } from 'rxjs/operators';
import * as i3$1 from '@spartacus/core';
import { GlobalMessageType, I18nModule, UrlModule, ConfigModule, CxDatePipe, useFeatureStyles, FeaturesConfigModule, provideDefaultConfig } from '@spartacus/core';
import * as i1 from '@spartacus/storefront';
import { FormUtils, ICON_TYPE, DIALOG_TYPE, FormErrorsModule, IconModule, KeyboardFocusModule, FileUploadModule, MessageComponentModule, PageComponentModule } from '@spartacus/storefront';
import * as i3 from '@spartacus/cart/import-export/core';
import { CartNameSource } from '@spartacus/cart/import-export/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import * as i6 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function ExportOrderEntriesComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function ExportOrderEntriesComponent_button_0_Template_button_click_0_listener() {
      const entries_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.exportCsv(entries_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "exportEntries.exportProductToCsv"), "\n");
  }
}
const _c0 = ["open"];
function ImportOrderEntriesComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function ImportOrderEntriesComponent_button_0_Template_button_click_0_listener() {
      const orderEntriesContext_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.openDialog(orderEntriesContext_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "importEntries.importProducts"), "\n");
  }
}
const _c1 = () => ({
  autofocus: ".cx-message"
});
function ImportEntriesFormComponent_form_0_ng_container_1_cx_message_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-message", 11);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 4, "importEntriesDialog.selectedSuccessfully"))("type", ctx_r1.globalMessageType.MSG_TYPE_CONFIRMATION)("isVisibleCloseButton", false)("cxFocus", i0.ɵɵpureFunction0(6, _c1));
  }
}
function ImportEntriesFormComponent_form_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtemplate(2, ImportEntriesFormComponent_form_0_ng_container_1_cx_message_2_Template, 2, 7, "cx-message", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ((tmp_2_0 = ctx_r1.form.get("file")) == null ? null : tmp_2_0.value) && ((tmp_2_0 = ctx_r1.form.get("file")) == null ? null : tmp_2_0.valid));
  }
}
function ImportEntriesFormComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 1);
    i0.ɵɵlistener("submit", function ImportEntriesFormComponent_form_0_Template_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.formSubmitSubject$.next(undefined));
    });
    i0.ɵɵtemplate(1, ImportEntriesFormComponent_form_0_ng_container_1_Template, 3, 1, "ng-container", 2);
    i0.ɵɵelementStart(2, "p", 3);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label")(9, "cx-file-upload", 4);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "cx-form-errors", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 6)(14, "button", 7);
    i0.ɵɵlistener("click", function ImportEntriesFormComponent_form_0_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close("Close Import Products Dialog"));
    });
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 8);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_10_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yCartImportConfirmationMessage");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 11, "importEntriesDialog.importProductsSubtitle"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 13, "importEntriesDialog.importProductFileDetails"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formControl", ctx_r1.form.get("file"))("accept", ctx_r1.allowedTypes);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 15, "importEntriesDialog.selectFile"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("file"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 17, "importEntriesDialog.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ((tmp_10_0 = ctx_r1.form.get("file")) == null ? null : tmp_10_0.status) === "PENDING");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 19, "importEntriesDialog.upload"), " ");
  }
}
const _c2 = a0 => ({
  count: a0
});
function ImportEntriesSummaryComponent_p_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "importEntriesDialog.summary.loaded", ctx_r0.summary), " ");
  }
}
function ImportEntriesSummaryComponent_p_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "importEntriesDialog.summary.loadedToCart", ctx_r0.summary), " ");
  }
}
function ImportEntriesSummaryComponent_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtemplate(1, ImportEntriesSummaryComponent_p_1_ng_container_1_Template, 3, 4, "ng-container", 10)(2, ImportEntriesSummaryComponent_p_1_ng_container_2_Template, 3, 4, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r0.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.orderEntriesSource.QUICK_ORDER);
  }
}
function ImportEntriesSummaryComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "importEntriesDialog.summary.loading", ctx_r0.summary), " ");
  }
}
function ImportEntriesSummaryComponent_p_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵelement(1, "cx-icon", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r0.iconTypes.SUCCESS);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 2, "importEntriesDialog.summary.successes", ctx_r0.summary), "\n");
  }
}
function ImportEntriesSummaryComponent_div_5_ul_8_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "importEntriesDialog.summary.messages." + message_r3.statusCode, message_r3), " ");
  }
}
function ImportEntriesSummaryComponent_div_5_ul_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, ImportEntriesSummaryComponent_div_5_ul_8_li_1_Template, 3, 4, "li", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.summary.warningMessages);
  }
}
function ImportEntriesSummaryComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "p");
    i0.ɵɵelement(2, "cx-icon", 15);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementStart(5, "button", 16);
    i0.ɵɵlistener("click", function ImportEntriesSummaryComponent_div_5_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleWarningList());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, ImportEntriesSummaryComponent_div_5_ul_8_Template, 2, 1, "ul", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r0.iconTypes.ERROR);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 4, "importEntriesDialog.summary.warning", i0.ɵɵpureFunction1(9, _c2, ctx_r0.summary.warningMessages.length)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 7, ctx_r0.warningDetailsOpened ? "importEntriesDialog.summary.hide" : "importEntriesDialog.summary.show"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.warningDetailsOpened);
  }
}
function ImportEntriesSummaryComponent_div_6_ul_8_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "importEntriesDialog.summary.messages." + message_r5.statusCode, message_r5), " ");
  }
}
function ImportEntriesSummaryComponent_div_6_ul_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, ImportEntriesSummaryComponent_div_6_ul_8_li_1_Template, 3, 4, "li", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.summary.errorMessages);
  }
}
function ImportEntriesSummaryComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "p");
    i0.ɵɵelement(2, "cx-icon", 20);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementStart(5, "button", 16);
    i0.ɵɵlistener("click", function ImportEntriesSummaryComponent_div_6_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleErrorList());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, ImportEntriesSummaryComponent_div_6_ul_8_Template, 2, 1, "ul", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r0.iconTypes.RESET);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 4, "importEntriesDialog.summary.error", i0.ɵɵpureFunction1(9, _c2, ctx_r0.summary.errorMessages.length)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 7, ctx_r0.errorDetailsOpened ? "importEntriesDialog.summary.hide" : "importEntriesDialog.summary.show"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.errorDetailsOpened);
  }
}
function ImportEntriesSummaryComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function ImportEntriesSummaryComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.close("Close Import Products Dialog"));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "importEntriesDialog.close"), " ");
  }
}
function ImportEntriesSummaryComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "importEntriesDialog.summary.info"));
  }
}
function ImportToNewSavedCartFormComponent_form_0_ng_container_1_cx_message_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-message", 22);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 4, "importEntriesDialog.selectedSuccessfully"))("type", ctx_r1.globalMessageType.MSG_TYPE_CONFIRMATION)("isVisibleCloseButton", false)("cxFocus", i0.ɵɵpureFunction0(6, _c1));
  }
}
function ImportToNewSavedCartFormComponent_form_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵtemplate(2, ImportToNewSavedCartFormComponent_form_0_ng_container_1_cx_message_2_Template, 2, 7, "cx-message", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ((tmp_3_0 = ctx_r1.form.get("file")) == null ? null : tmp_3_0.value) && ((tmp_3_0 = ctx_r1.form.get("file")) == null ? null : tmp_3_0.valid));
  }
}
function ImportToNewSavedCartFormComponent_form_0_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "formLegend.required"), " ");
  }
}
function ImportToNewSavedCartFormComponent_form_0_ng_template_9_Template(rf, ctx) {}
function ImportToNewSavedCartFormComponent_form_0_ng_template_20_Template(rf, ctx) {}
function ImportToNewSavedCartFormComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 2);
    i0.ɵɵlistener("submit", function ImportToNewSavedCartFormComponent_form_0_Template_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.formSubmitSubject$.next(undefined));
    });
    i0.ɵɵtemplate(1, ImportToNewSavedCartFormComponent_form_0_ng_container_1_Template, 3, 1, "ng-container", 3)(2, ImportToNewSavedCartFormComponent_form_0_p_2_Template, 3, 3, "p", 4);
    i0.ɵɵelementStart(3, "p", 5);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵtemplate(9, ImportToNewSavedCartFormComponent_form_0_ng_template_9_Template, 0, 0, "ng-template", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "label")(11, "cx-file-upload", 7);
    i0.ɵɵlistener("update", function ImportToNewSavedCartFormComponent_form_0_Template_cx_file_upload_update_11_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateCartName());
    });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "cx-form-errors", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 9)(16, "label")(17, "span", 10);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵtemplate(20, ImportToNewSavedCartFormComponent_form_0_ng_template_20_Template, 0, 0, "ng-template", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 11)(22, "cx-form-errors", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "div", 9)(24, "label")(25, "span", 10);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementStart(28, "span", 13);
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(31, "textarea", 14)(32, "cx-form-errors", 15);
    i0.ɵɵelementStart(33, "p", 16);
    i0.ɵɵtext(34);
    i0.ɵɵpipe(35, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(36, "div", 17)(37, "button", 18);
    i0.ɵɵlistener("click", function ImportToNewSavedCartFormComponent_form_0_Template_button_click_37_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close("Close Import Products Dialog"));
    });
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "button", 19);
    i0.ɵɵtext(41);
    i0.ɵɵpipe(42, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_23_0;
    const ctx_r1 = i0.ɵɵnextContext();
    const requiredAsterisk_r3 = i0.ɵɵreference(2);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yCartImportConfirmationMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 23, "importEntriesDialog.importProductsNewSavedCartSubtitle"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 25, "importEntriesDialog.importProductFileDetails"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.form.get("file"))("accept", ctx_r1.allowedTypes);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 27, "importEntriesDialog.selectFile"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("file"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 29, "importEntriesDialog.savedCartName"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("maxLength", ctx_r1.nameMaxLength);
    i0.ɵɵattribute("aria-describedby", "nameError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r1.form.get("name"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 31, "importEntriesDialog.savedCartDescription"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" (", i0.ɵɵpipeBind1(30, 33, "importEntriesDialog.optional"), ") ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("maxLength", ctx_r1.descriptionMaxLength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", ctx_r1.form.get("description"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(35, 35, "importEntriesDialog.charactersLeft", i0.ɵɵpureFunction1(42, _c2, ctx_r1.descriptionsCharacterLeft)), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(39, 38, "importEntriesDialog.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ((tmp_23_0 = ctx_r1.form.get("file")) == null ? null : tmp_23_0.status) === "PENDING");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(42, 40, "importEntriesDialog.upload"), " ");
  }
}
function ImportToNewSavedCartFormComponent_ng_template_1_abbr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "abbr", 25);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2, "*");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "common.required"));
  }
}
function ImportToNewSavedCartFormComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ImportToNewSavedCartFormComponent_ng_template_1_abbr_0_Template, 3, 3, "abbr", 24);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFeature", "a11yRequiredAsterisks");
  }
}
function ImportEntriesDialogComponent_h3_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "importEntriesDialog.importProducts"), " ");
  }
}
function ImportEntriesDialogComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "importEntriesDialog.importProducts"), " ");
  }
}
function ImportEntriesDialogComponent_ng_container_12_ng_container_1_cx_import_to_new_saved_cart_form_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-import-to-new-saved-cart-form", 13);
    i0.ɵɵlistener("submitEvent", function ImportEntriesDialogComponent_ng_container_12_ng_container_1_cx_import_to_new_saved_cart_form_1_Template_cx_import_to_new_saved_cart_form_submitEvent_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const context_r2 = i0.ɵɵnextContext(2).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.importProducts(context_r2, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const context_r2 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("type", context_r2.type);
  }
}
function ImportEntriesDialogComponent_ng_container_12_ng_container_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-import-entries-form", 13);
    i0.ɵɵlistener("submitEvent", function ImportEntriesDialogComponent_ng_container_12_ng_container_1_ng_template_2_Template_cx_import_entries_form_submitEvent_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const context_r2 = i0.ɵɵnextContext(2).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.importProducts(context_r2, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const context_r2 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("type", context_r2.type);
  }
}
function ImportEntriesDialogComponent_ng_container_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImportEntriesDialogComponent_ng_container_12_ng_container_1_cx_import_to_new_saved_cart_form_1_Template, 1, 1, "cx-import-to-new-saved-cart-form", 12)(2, ImportEntriesDialogComponent_ng_container_12_ng_container_1_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const reducedForm_r5 = i0.ɵɵreference(3);
    const context_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isNewCartForm(context_r2))("ngIfElse", reducedForm_r5);
  }
}
function ImportEntriesDialogComponent_ng_container_12_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-import-entries-summary", 14);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("closeEvent", function ImportEntriesDialogComponent_ng_container_12_ng_template_2_Template_cx_import_entries_summary_closeEvent_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.close("Close Import Products Dialog"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const context_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("summary", i0.ɵɵpipeBind1(1, 2, ctx_r2.summary$))("type", context_r2.type);
  }
}
function ImportEntriesDialogComponent_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImportEntriesDialogComponent_ng_container_12_ng_container_1_Template, 4, 2, "ng-container", 11)(2, ImportEntriesDialogComponent_ng_container_12_ng_template_2_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const importSummary_r7 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.formState)("ngIfElse", importSummary_r7);
  }
}
function ImportExportOrderEntriesComponent_cx_import_order_entries_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-import-order-entries");
  }
}
function ImportExportOrderEntriesComponent_cx_export_order_entries_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-export-order-entries");
  }
}
class ExportOrderEntriesToCsvService {
  constructor(exportCsvFileService, importExportConfig, globalMessageService, translationService) {
    this.exportCsvFileService = exportCsvFileService;
    this.importExportConfig = importExportConfig;
    this.globalMessageService = globalMessageService;
    this.translationService = translationService;
    this.columns = [{
      name: {
        key: 'code'
      },
      value: 'product.code'
    }, {
      name: {
        key: 'quantity'
      },
      value: 'quantity'
    }, ...(this.exportConfig?.additionalColumns ?? [])];
  }
  get exportConfig() {
    return this.importExportConfig.cartImportExport?.export;
  }
  get separator() {
    return this.importExportConfig.cartImportExport?.file.separator;
  }
  downloadCsv(entries) {
    this.getResolvedEntries(entries).pipe(take(1)).subscribe(csvData => this.download(csvData));
  }
  resolveValue(combinedKeys, entry) {
    return combinedKeys.split('.').reduce((obj, key) => obj ? obj[key] : '', entry)?.toString() ?? '';
  }
  resolveValues(entries) {
    return entries.map(entry => this.columns.map(column => this.resolveValue(column.value, entry)));
  }
  getTranslatedColumnHeaders() {
    return combineLatest(this.columns.map(column => this.translationService.translate(`exportEntries.columnNames.${column.name.key}`)));
  }
  displayExportMessage() {
    this.globalMessageService.add({
      key: 'exportEntries.exportMessage'
    }, GlobalMessageType.MSG_TYPE_INFO);
  }
  limitValues(data) {
    return this.exportConfig?.maxEntries ? data.splice(0, this.exportConfig?.maxEntries) : data;
  }
  getResolvedEntries(entries) {
    const values = this.limitValues(this.resolveValues(entries));
    return this.getTranslatedColumnHeaders().pipe(map(headers => {
      return [headers, ...values];
    }));
  }
  download(entries) {
    if (this.exportConfig?.messageEnabled) {
      this.displayExportMessage();
    }
    setTimeout(() => {
      if (this.exportConfig !== undefined && this.separator !== undefined) {
        this.exportCsvFileService.download(entries, this.separator, this.exportConfig.fileOptions);
      }
    }, this.exportConfig?.downloadDelay ?? 0);
  }
  static {
    this.ɵfac = function ExportOrderEntriesToCsvService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ExportOrderEntriesToCsvService)(i0.ɵɵinject(i1.ExportCsvFileService), i0.ɵɵinject(i3.ImportExportConfig), i0.ɵɵinject(i3$1.GlobalMessageService), i0.ɵɵinject(i3$1.TranslationService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ExportOrderEntriesToCsvService,
      factory: ExportOrderEntriesToCsvService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExportOrderEntriesToCsvService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ExportCsvFileService
  }, {
    type: i3.ImportExportConfig
  }, {
    type: i3$1.GlobalMessageService
  }, {
    type: i3$1.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ExportOrderEntriesComponent {
  constructor(exportEntriesService, contextService) {
    this.exportEntriesService = exportEntriesService;
    this.contextService = contextService;
    this.styles = 'container';
    this.orderEntriesContext$ = this.contextService.get(ORDER_ENTRIES_CONTEXT);
    this.entries$ = this.orderEntriesContext$.pipe(switchMap(orderEntriesContext => orderEntriesContext?.getEntries?.() ?? of(undefined)));
  }
  exportCsv(entries) {
    this.exportEntriesService.downloadCsv(entries);
  }
  static {
    this.ɵfac = function ExportOrderEntriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ExportOrderEntriesComponent)(i0.ɵɵdirectiveInject(ExportOrderEntriesToCsvService), i0.ɵɵdirectiveInject(i1.ContextService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ExportOrderEntriesComponent,
      selectors: [["cx-export-order-entries"]],
      hostVars: 2,
      hostBindings: function ExportOrderEntriesComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styles);
        }
      },
      standalone: false,
      decls: 3,
      vars: 5,
      consts: [["class", "btn btn-tertiary cx-export-btn", 3, "click", 4, "ngIf"], [1, "btn", "btn-tertiary", "cx-export-btn", 3, "click"]],
      template: function ExportOrderEntriesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ExportOrderEntriesComponent_button_0_Template, 3, 3, "button", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵpipe(2, "async");
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵproperty("ngIf", ((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.entries$)) == null ? null : tmp_0_0.length) > 0 && i0.ɵɵpipeBind1(2, 3, ctx.entries$));
        }
      },
      dependencies: [i1$1.NgIf, i1$1.AsyncPipe, i3$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExportOrderEntriesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-export-order-entries',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<button\n  *ngIf=\"(entries$ | async)?.length > 0 && (entries$ | async) as entries\"\n  class=\"btn btn-tertiary cx-export-btn\"\n  (click)=\"exportCsv(entries)\"\n>\n  {{ 'exportEntries.exportProductToCsv' | cxTranslate }}\n</button>\n"
    }]
  }], () => [{
    type: ExportOrderEntriesToCsvService
  }, {
    type: i1.ContextService
  }], {
    styles: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ExportOrderEntriesModule {
  static {
    this.ɵfac = function ExportOrderEntriesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ExportOrderEntriesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ExportOrderEntriesModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, ConfigModule.withConfig({
        cmsComponents: {
          ExportOrderEntriesComponent: {
            component: ExportOrderEntriesComponent
          }
        }
      })]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExportOrderEntriesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, I18nModule, UrlModule, ConfigModule.withConfig({
        cmsComponents: {
          ExportOrderEntriesComponent: {
            component: ExportOrderEntriesComponent
          }
        }
      })],
      exports: [ExportOrderEntriesComponent],
      declarations: [ExportOrderEntriesComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportOrderEntriesComponent {
  constructor(launchDialogService, contextService) {
    this.launchDialogService = launchDialogService;
    this.contextService = contextService;
    this.subscription = new Subscription();
    this.orderEntriesContext$ = this.contextService.get(ORDER_ENTRIES_CONTEXT);
  }
  openDialog(orderEntriesContext) {
    this.launchDialogService.openDialogAndSubscribe("IMPORT_TO_CART" /* LAUNCH_CALLER.IMPORT_TO_CART */, this.element, {
      orderEntriesContext
    });
  }
  static {
    this.ɵfac = function ImportOrderEntriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportOrderEntriesComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(i1.ContextService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImportOrderEntriesComponent,
      selectors: [["cx-import-order-entries"]],
      viewQuery: function ImportOrderEntriesComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["class", "btn btn-tertiary cx-import-btn", 3, "click", 4, "ngIf"], [1, "btn", "btn-tertiary", "cx-import-btn", 3, "click"]],
      template: function ImportOrderEntriesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ImportOrderEntriesComponent_button_0_Template, 3, 3, "button", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.orderEntriesContext$));
        }
      },
      dependencies: [i1$1.NgIf, i1$1.AsyncPipe, i3$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportOrderEntriesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-import-order-entries',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<button\n  *ngIf=\"orderEntriesContext$ | async as orderEntriesContext\"\n  class=\"btn btn-tertiary cx-import-btn\"\n  (click)=\"openDialog(orderEntriesContext)\"\n>\n  {{ 'importEntries.importProducts' | cxTranslate }}\n</button>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }, {
    type: i1.ContextService
  }], {
    element: [{
      type: ViewChild,
      args: ['open']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportProductsFromCsvService {
  constructor() {
    // Intentional empty constructor
  }
  csvDataToProduct(csvData) {
    return csvData.map(row => ({
      productCode: row[0],
      quantity: Number(row[1])
    }));
  }
  isDataParsableToProducts(data) {
    const patternRegex = new RegExp(/(?:\s|^)\d+(?=\s|$)/);
    return data.length > 0 && data.every(row => patternRegex.test(row[1]));
  }
  static {
    this.ɵfac = function ImportProductsFromCsvService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportProductsFromCsvService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ImportProductsFromCsvService,
      factory: ImportProductsFromCsvService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportProductsFromCsvService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportEntriesFormComponent {
  constructor(launchDialogService, importToCartService, importCsvService, filesFormValidators, importExportConfig) {
    this.launchDialogService = launchDialogService;
    this.importToCartService = importToCartService;
    this.importCsvService = importCsvService;
    this.filesFormValidators = filesFormValidators;
    this.importExportConfig = importExportConfig;
    this.formSubmitSubject$ = new Subject();
    this.globalMessageType = GlobalMessageType;
    this.submitEvent = new EventEmitter();
  }
  ngOnInit() {
    this.form = this.buildForm();
    this.formSubmitSubject$.pipe(tap(() => {
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        FormUtils.deepUpdateValueAndValidity(this.form);
      }
    }), switchMap(() => this.form.statusChanges.pipe(startWith(this.form.get('file')?.status), filter(status => status !== 'PENDING'), take(1))), filter(status => status === 'VALID')).subscribe(() => {
      this.save();
    });
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  save() {
    const file = this.form.get('file')?.value?.[0];
    if (this.separator !== undefined) {
      this.importCsvService.loadFile(file, this.separator).subscribe(loadedFile => {
        this.submitEvent.emit({
          products: this.importToCartService.csvDataToProduct(loadedFile)
        });
      });
    }
  }
  buildForm() {
    const form = new UntypedFormGroup({});
    form.setControl('file', new UntypedFormControl('', [Validators.required, this.filesFormValidators.maxSize(this.maxSize)], [control => this.separator !== undefined ? this.importCsvService.validateFile(control.value[0], {
      separator: this.separator,
      isDataParsable: this.importToCartService.isDataParsableToProducts,
      maxEntries: this.maxEntries
    }) : of(null)]));
    return form;
  }
  get allowedTypes() {
    return this.importExportConfig.cartImportExport?.import?.fileValidity?.allowedTypes;
  }
  get maxSize() {
    return this.importExportConfig.cartImportExport?.import?.fileValidity?.maxSize;
  }
  get maxEntries() {
    return this.importExportConfig.cartImportExport?.import?.fileValidity?.maxEntries?.[this.type];
  }
  get separator() {
    return this.importExportConfig.cartImportExport?.file.separator;
  }
  static {
    this.ɵfac = function ImportEntriesFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportEntriesFormComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(ImportProductsFromCsvService), i0.ɵɵdirectiveInject(i1.ImportCsvFileService), i0.ɵɵdirectiveInject(i1.FilesFormValidators), i0.ɵɵdirectiveInject(i3.ImportExportConfig));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImportEntriesFormComponent,
      selectors: [["cx-import-entries-form"]],
      inputs: {
        type: "type"
      },
      outputs: {
        submitEvent: "submitEvent"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[3, "formGroup", "submit", 4, "ngIf"], [3, "submit", "formGroup"], [4, "cxFeature"], [1, "cx-import-entries-subtitle"], [3, "formControl", "accept"], ["prefix", "formErrors.file", 3, "control"], [1, "cx-import-entries-footer"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["type", "submit", 1, "btn", "btn-primary", 3, "disabled"], ["aria-live", "assertive", "aria-atomic", "true"], [3, "text", "type", "isVisibleCloseButton", "cxFocus", 4, "ngIf"], [3, "text", "type", "isVisibleCloseButton", "cxFocus"]],
      template: function ImportEntriesFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ImportEntriesFormComponent_form_0_Template, 20, 21, "form", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.form);
        }
      },
      dependencies: [i1$1.NgIf, i6.ɵNgNoValidate, i6.NgControlStatus, i6.NgControlStatusGroup, i6.FormControlDirective, i6.FormGroupDirective, i1.FormErrorsComponent, i1.FocusDirective, i1.FileUploadComponent, i1.MessageComponent, i3$1.FeatureDirective, i3$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportEntriesFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-import-entries-form',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<form\n  *ngIf=\"form\"\n  [formGroup]=\"form\"\n  (submit)=\"formSubmitSubject$.next(undefined)\"\n>\n  <ng-container *cxFeature=\"'a11yCartImportConfirmationMessage'\">\n    <div aria-live=\"assertive\" aria-atomic=\"true\">\n      <cx-message\n        *ngIf=\"form.get('file')?.value && form.get('file')?.valid\"\n        [text]=\"'importEntriesDialog.selectedSuccessfully' | cxTranslate\"\n        [type]=\"globalMessageType.MSG_TYPE_CONFIRMATION\"\n        [isVisibleCloseButton]=\"false\"\n        [cxFocus]=\"{ autofocus: '.cx-message' }\"\n      ></cx-message>\n    </div>\n  </ng-container>\n  <p class=\"cx-import-entries-subtitle\">\n    {{ 'importEntriesDialog.importProductsSubtitle' | cxTranslate }}\n  </p>\n  <p>\n    {{ 'importEntriesDialog.importProductFileDetails' | cxTranslate }}\n  </p>\n  <label>\n    <cx-file-upload [formControl]=\"form.get('file')\" [accept]=\"allowedTypes\">\n      {{ 'importEntriesDialog.selectFile' | cxTranslate }}\n    </cx-file-upload>\n    <cx-form-errors\n      [control]=\"form.get('file')\"\n      prefix=\"formErrors.file\"\n    ></cx-form-errors>\n  </label>\n  <div class=\"cx-import-entries-footer\">\n    <button\n      (click)=\"close('Close Import Products Dialog')\"\n      class=\"btn btn-secondary\"\n      type=\"button\"\n    >\n      {{ 'importEntriesDialog.cancel' | cxTranslate }}\n    </button>\n    <button\n      class=\"btn btn-primary\"\n      type=\"submit\"\n      [disabled]=\"form.get('file')?.status === 'PENDING'\"\n    >\n      {{ 'importEntriesDialog.upload' | cxTranslate }}\n    </button>\n  </div>\n</form>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }, {
    type: ImportProductsFromCsvService
  }, {
    type: i1.ImportCsvFileService
  }, {
    type: i1.FilesFormValidators
  }, {
    type: i3.ImportExportConfig
  }], {
    submitEvent: [{
      type: Output
    }],
    type: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportEntriesSummaryComponent {
  constructor() {
    this.iconTypes = ICON_TYPE;
    this.orderEntriesSource = OrderEntriesSource;
    this.warningDetailsOpened = false;
    this.errorDetailsOpened = false;
    this.closeEvent = new EventEmitter();
  }
  close(reason) {
    this.closeEvent.emit(reason);
  }
  toggleWarningList() {
    this.warningDetailsOpened = !this.warningDetailsOpened;
  }
  toggleErrorList() {
    this.errorDetailsOpened = !this.errorDetailsOpened;
  }
  static {
    this.ɵfac = function ImportEntriesSummaryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportEntriesSummaryComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImportEntriesSummaryComponent,
      selectors: [["cx-import-entries-summary"]],
      inputs: {
        type: "type",
        summary: "summary"
      },
      outputs: {
        closeEvent: "closeEvent"
      },
      standalone: false,
      decls: 11,
      vars: 7,
      consts: [["loading", ""], ["info", ""], [1, "cx-import-entries-summary-status"], [3, "ngSwitch", 4, "ngIf", "ngIfElse"], ["class", "cx-import-entries-summary-successes", 4, "ngIf"], ["class", "cx-import-entries-summary-warnings", 4, "ngIf"], ["class", "cx-import-entries-summary-errors", 4, "ngIf"], [1, "cx-import-entries-summary-footer"], ["class", "btn btn-secondary", "type", "button", 3, "click", 4, "ngIf", "ngIfElse"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "cx-import-entries-summary-successes"], [1, "success", 3, "type"], [1, "cx-import-entries-summary-warnings"], [1, "warning", 3, "type"], [1, "btn", "btn-tertiary", 3, "click"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "cx-import-entries-summary-errors"], [1, "error", 3, "type"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"]],
      template: function ImportEntriesSummaryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵtemplate(1, ImportEntriesSummaryComponent_p_1_Template, 3, 2, "p", 3)(2, ImportEntriesSummaryComponent_ng_template_2_Template, 3, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, ImportEntriesSummaryComponent_p_4_Template, 4, 5, "p", 4)(5, ImportEntriesSummaryComponent_div_5_Template, 9, 11, "div", 5)(6, ImportEntriesSummaryComponent_div_6_Template, 9, 11, "div", 6);
          i0.ɵɵelementStart(7, "div", 7);
          i0.ɵɵtemplate(8, ImportEntriesSummaryComponent_button_8_Template, 3, 3, "button", 8)(9, ImportEntriesSummaryComponent_ng_template_9_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          const loading_r7 = i0.ɵɵreference(3);
          const info_r8 = i0.ɵɵreference(10);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.summary.loading)("ngIfElse", loading_r7);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.summary.successesCount > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.summary.warningMessages.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.summary.errorMessages.length > 0);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.summary.loading)("ngIfElse", info_r8);
        }
      },
      dependencies: [i1$1.NgForOf, i1$1.NgIf, i1$1.NgSwitch, i1$1.NgSwitchCase, i1$1.NgSwitchDefault, i1.IconComponent, i3$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportEntriesSummaryComponent, [{
    type: Component,
    args: [{
      selector: 'cx-import-entries-summary',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"cx-import-entries-summary-status\">\n  <p *ngIf=\"!summary.loading; else loading\" [ngSwitch]=\"type\">\n    <ng-container *ngSwitchCase=\"orderEntriesSource.QUICK_ORDER\">\n      {{ 'importEntriesDialog.summary.loaded' | cxTranslate: summary }}\n    </ng-container>\n    <ng-container *ngSwitchDefault>\n      {{ 'importEntriesDialog.summary.loadedToCart' | cxTranslate: summary }}\n    </ng-container>\n  </p>\n  <ng-template #loading>\n    <p>\n      {{ 'importEntriesDialog.summary.loading' | cxTranslate: summary }}\n    </p>\n  </ng-template>\n</div>\n<p\n  *ngIf=\"summary.successesCount > 0\"\n  class=\"cx-import-entries-summary-successes\"\n>\n  <cx-icon class=\"success\" [type]=\"iconTypes.SUCCESS\"></cx-icon>\n  {{ 'importEntriesDialog.summary.successes' | cxTranslate: summary }}\n</p>\n<div\n  *ngIf=\"summary.warningMessages.length > 0\"\n  class=\"cx-import-entries-summary-warnings\"\n>\n  <p>\n    <cx-icon class=\"warning\" [type]=\"iconTypes.ERROR\"></cx-icon>\n    {{\n      'importEntriesDialog.summary.warning'\n        | cxTranslate: { count: summary.warningMessages.length }\n    }}\n    <button class=\"btn btn-tertiary\" (click)=\"toggleWarningList()\">\n      {{\n        (warningDetailsOpened\n          ? 'importEntriesDialog.summary.hide'\n          : 'importEntriesDialog.summary.show'\n        ) | cxTranslate\n      }}\n    </button>\n  </p>\n  <ul *ngIf=\"warningDetailsOpened\">\n    <li *ngFor=\"let message of summary.warningMessages\">\n      {{\n        'importEntriesDialog.summary.messages.' + message.statusCode\n          | cxTranslate: message\n      }}\n    </li>\n  </ul>\n</div>\n<div\n  *ngIf=\"summary.errorMessages.length > 0\"\n  class=\"cx-import-entries-summary-errors\"\n>\n  <p>\n    <cx-icon class=\"error\" [type]=\"iconTypes.RESET\"></cx-icon>\n    {{\n      'importEntriesDialog.summary.error'\n        | cxTranslate: { count: summary.errorMessages.length }\n    }}\n    <button class=\"btn btn-tertiary\" (click)=\"toggleErrorList()\">\n      {{\n        (errorDetailsOpened\n          ? 'importEntriesDialog.summary.hide'\n          : 'importEntriesDialog.summary.show'\n        ) | cxTranslate\n      }}\n    </button>\n  </p>\n  <ul *ngIf=\"errorDetailsOpened\">\n    <li *ngFor=\"let message of summary.errorMessages\">\n      {{\n        'importEntriesDialog.summary.messages.' + message.statusCode\n          | cxTranslate: message\n      }}\n    </li>\n  </ul>\n</div>\n<div class=\"cx-import-entries-summary-footer\">\n  <button\n    *ngIf=\"!summary.loading; else info\"\n    (click)=\"close('Close Import Products Dialog')\"\n    class=\"btn btn-secondary\"\n    type=\"button\"\n  >\n    {{ 'importEntriesDialog.close' | cxTranslate }}\n  </button>\n  <ng-template #info>\n    <p>{{ 'importEntriesDialog.summary.info' | cxTranslate }}</p>\n  </ng-template>\n</div>\n"
    }]
  }], null, {
    type: [{
      type: Input
    }],
    summary: [{
      type: Input
    }],
    closeEvent: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportToNewSavedCartFormComponent extends ImportEntriesFormComponent {
  get descriptionsCharacterLeft() {
    return this.descriptionMaxLength - (this.form.get('description')?.value?.length || 0);
  }
  constructor(launchDialogService, importToCartService, importCsvService, filesFormValidators, importExportConfig, datePipe) {
    super(launchDialogService, importToCartService, importCsvService, filesFormValidators, importExportConfig);
    this.launchDialogService = launchDialogService;
    this.importToCartService = importToCartService;
    this.importCsvService = importCsvService;
    this.filesFormValidators = filesFormValidators;
    this.importExportConfig = importExportConfig;
    this.datePipe = datePipe;
    this.descriptionMaxLength = 250;
    this.nameMaxLength = 50;
    this.submitEvent = new EventEmitter();
  }
  save() {
    const file = this.form.get('file')?.value?.[0];
    if (this.separator !== undefined) {
      this.importCsvService.loadFile(file, this.separator).subscribe(loadedFile => {
        this.submitEvent.emit({
          products: this.importToCartService.csvDataToProduct(loadedFile),
          savedCartInfo: {
            name: this.form.get('name')?.value,
            description: this.form.get('description')?.value
          }
        });
      });
    }
  }
  buildForm() {
    const form = new UntypedFormGroup({});
    form.setControl('file', new UntypedFormControl('', [Validators.required, this.filesFormValidators.maxSize(this.maxSize)], [control => this.separator !== undefined ? this.importCsvService.validateFile(control.value[0], {
      separator: this.separator,
      isDataParsable: this.importToCartService.isDataParsableToProducts,
      maxEntries: this.maxEntries
    }) : of(null)]));
    form.setControl('name', new UntypedFormControl('', [Validators.required, Validators.maxLength(this.nameMaxLength)]));
    form.setControl('description', new UntypedFormControl('', [Validators.maxLength(this.descriptionMaxLength)]));
    return form;
  }
  updateCartName() {
    const nameField = this.form.get('name');
    if (nameField && !nameField?.value && this.cartNameGeneration?.source) {
      switch (this.cartNameGeneration.source) {
        case CartNameSource.FILE_NAME:
          {
            this.setFieldValueByFileName(nameField);
            break;
          }
        case CartNameSource.DATE_TIME:
          {
            this.setFieldValueByDatetime(nameField);
            break;
          }
        default:
          {
            break;
          }
      }
    }
  }
  setFieldValueByFileName(nameField) {
    const fileName = this.form.get('file')?.value?.[0]?.name?.replace(/\.[^/.]+$/, '');
    nameField.setValue(fileName);
  }
  setFieldValueByDatetime(nameField) {
    const date = new Date();
    const fromDateOptions = this.cartNameGeneration?.fromDateOptions;
    const mask = fromDateOptions?.mask;
    const prefix = fromDateOptions?.prefix ?? '';
    const suffix = fromDateOptions?.suffix ?? '';
    const dateString = mask ? this.datePipe.transform(date, mask) : this.datePipe.transform(date);
    nameField.setValue(`${prefix}${dateString}${suffix}`);
  }
  get cartNameGeneration() {
    return this.importExportConfig.cartImportExport?.import?.cartNameGeneration;
  }
  static {
    this.ɵfac = function ImportToNewSavedCartFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportToNewSavedCartFormComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(ImportProductsFromCsvService), i0.ɵɵdirectiveInject(i1.ImportCsvFileService), i0.ɵɵdirectiveInject(i1.FilesFormValidators), i0.ɵɵdirectiveInject(i3.ImportExportConfig), i0.ɵɵdirectiveInject(i3$1.CxDatePipe));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImportToNewSavedCartFormComponent,
      selectors: [["cx-import-to-new-saved-cart-form"]],
      outputs: {
        submitEvent: "submitEvent"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([CxDatePipe]), i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 1,
      consts: [["requiredAsterisk", ""], [3, "formGroup", "submit", 4, "ngIf"], [3, "submit", "formGroup"], [4, "cxFeature"], ["class", "form-legend", 4, "cxFeature"], [1, "cx-import-entries-subtitle"], [3, "ngTemplateOutlet"], [3, "update", "formControl", "accept"], ["prefix", "formErrors.file", 3, "control"], [1, "cx-import-entries-row"], [1, "cx-import-entries-label", "label-content"], ["formControlName", "name", "required", "", "type", "text", 1, "form-control", 3, "maxLength"], ["id", "nameError", "aria-live", "off", 3, "control"], [1, "cx-import-entries-label-optional"], ["formControlName", "description", "rows", "5", 1, "form-control", 3, "maxLength"], [3, "control"], [1, "cx-import-entries-input-hint"], [1, "cx-import-entries-footer"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["type", "submit", 1, "btn", "btn-primary", 3, "disabled"], ["aria-live", "assertive", "aria-atomic", "true"], [3, "text", "type", "isVisibleCloseButton", "cxFocus", 4, "ngIf"], [3, "text", "type", "isVisibleCloseButton", "cxFocus"], [1, "form-legend"], ["class", "text-decoration-none required-asterisk", "aria-hidden", "true", 3, "title", 4, "cxFeature"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
      template: function ImportToNewSavedCartFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ImportToNewSavedCartFormComponent_form_0_Template, 43, 44, "form", 1)(1, ImportToNewSavedCartFormComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.form);
        }
      },
      dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i6.ɵNgNoValidate, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgControlStatusGroup, i6.RequiredValidator, i6.FormControlDirective, i6.FormGroupDirective, i6.FormControlName, i1.FormErrorsComponent, i1.FocusDirective, i1.FileUploadComponent, i1.MessageComponent, i3$1.FeatureDirective, i3$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportToNewSavedCartFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-import-to-new-saved-cart-form',
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [CxDatePipe],
      standalone: false,
      template: "<form\n  *ngIf=\"form\"\n  [formGroup]=\"form\"\n  (submit)=\"formSubmitSubject$.next(undefined)\"\n>\n  <ng-container *cxFeature=\"'a11yCartImportConfirmationMessage'\">\n    <div aria-live=\"assertive\" aria-atomic=\"true\">\n      <cx-message\n        *ngIf=\"form.get('file')?.value && form.get('file')?.valid\"\n        [text]=\"'importEntriesDialog.selectedSuccessfully' | cxTranslate\"\n        [type]=\"globalMessageType.MSG_TYPE_CONFIRMATION\"\n        [isVisibleCloseButton]=\"false\"\n        [cxFocus]=\"{ autofocus: '.cx-message' }\"\n      ></cx-message>\n    </div>\n  </ng-container>\n  <p *cxFeature=\"'a11yRequiredAsterisks'\" class=\"form-legend\">\n    {{ 'formLegend.required' | cxTranslate }}\n  </p>\n  <p class=\"cx-import-entries-subtitle\">\n    {{ 'importEntriesDialog.importProductsNewSavedCartSubtitle' | cxTranslate }}\n  </p>\n  <p>\n    {{ 'importEntriesDialog.importProductFileDetails' | cxTranslate }}\n    <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n  </p>\n  <label>\n    <cx-file-upload\n      [formControl]=\"form.get('file')\"\n      (update)=\"updateCartName()\"\n      [accept]=\"allowedTypes\"\n    >\n      {{ 'importEntriesDialog.selectFile' | cxTranslate }}\n    </cx-file-upload>\n    <cx-form-errors\n      [control]=\"form.get('file')\"\n      prefix=\"formErrors.file\"\n    ></cx-form-errors>\n  </label>\n  <div class=\"cx-import-entries-row\">\n    <label>\n      <span class=\"cx-import-entries-label label-content\">\n        {{ 'importEntriesDialog.savedCartName' | cxTranslate }}\n        <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n      </span>\n      <input\n        [maxLength]=\"nameMaxLength\"\n        class=\"form-control\"\n        formControlName=\"name\"\n        required\n        type=\"text\"\n        [attr.aria-describedby]=\"'nameError'\"\n      />\n      <cx-form-errors\n        id=\"nameError\"\n        aria-live=\"off\"\n        [control]=\"form.get('name')\"\n      ></cx-form-errors>\n    </label>\n  </div>\n\n  <div class=\"cx-import-entries-row\">\n    <label>\n      <span class=\"cx-import-entries-label label-content\">\n        {{ 'importEntriesDialog.savedCartDescription' | cxTranslate }}\n        <span class=\"cx-import-entries-label-optional\">\n          ({{ 'importEntriesDialog.optional' | cxTranslate }})\n        </span></span\n      >\n      <textarea\n        [maxLength]=\"descriptionMaxLength\"\n        class=\"form-control\"\n        formControlName=\"description\"\n        rows=\"5\"\n      ></textarea>\n      <cx-form-errors [control]=\"form.get('description')\"></cx-form-errors>\n\n      <p class=\"cx-import-entries-input-hint\">\n        {{\n          'importEntriesDialog.charactersLeft'\n            | cxTranslate: { count: descriptionsCharacterLeft }\n        }}\n      </p>\n    </label>\n  </div>\n  <div class=\"cx-import-entries-footer\">\n    <button\n      (click)=\"close('Close Import Products Dialog')\"\n      class=\"btn btn-secondary\"\n      type=\"button\"\n    >\n      {{ 'importEntriesDialog.cancel' | cxTranslate }}\n    </button>\n    <button\n      class=\"btn btn-primary\"\n      type=\"submit\"\n      [disabled]=\"form.get('file')?.status === 'PENDING'\"\n    >\n      {{ 'importEntriesDialog.upload' | cxTranslate }}\n    </button>\n  </div>\n</form>\n\n<ng-template #requiredAsterisk>\n  <abbr\n    *cxFeature=\"'a11yRequiredAsterisks'\"\n    class=\"text-decoration-none required-asterisk\"\n    aria-hidden=\"true\"\n    title=\"{{ 'common.required' | cxTranslate }}\"\n    >*</abbr\n  >\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }, {
    type: ImportProductsFromCsvService
  }, {
    type: i1.ImportCsvFileService
  }, {
    type: i1.FilesFormValidators
  }, {
    type: i3.ImportExportConfig
  }, {
    type: i3$1.CxDatePipe
  }], {
    submitEvent: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportEntriesDialogComponent {
  constructor(launchDialogService) {
    this.launchDialogService = launchDialogService;
    this.iconTypes = ICON_TYPE;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
    this.formState = true;
    this.summary$ = new BehaviorSubject({
      loading: false,
      cartName: '',
      count: 0,
      total: 0,
      successesCount: 0,
      warningMessages: [],
      errorMessages: []
    });
    this.context$ = this.launchDialogService.data$.pipe(map(data => data.orderEntriesContext));
    useFeatureStyles('a11yExpandedFocusIndicator');
    useFeatureStyles('a11yVisibleFocusOverflows');
  }
  isNewCartForm(context) {
    return context.type === OrderEntriesSource.NEW_SAVED_CART;
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  importProducts(context, {
    products,
    savedCartInfo
  }) {
    this.formState = false;
    this.summary$.next({
      ...this.summary$.value,
      loading: true,
      total: products.length,
      cartName: savedCartInfo?.name
    });
    context.addEntries(products, savedCartInfo).pipe(finalize(() => {
      this.summary$.next({
        ...this.summary$.value,
        loading: false
      });
    })).subscribe(action => {
      this.populateSummary(action);
    });
  }
  populateSummary(action) {
    if (action.statusCode === ProductImportStatus.SUCCESS) {
      this.summary$.next({
        ...this.summary$.value,
        count: this.summary$.value.count + 1,
        successesCount: this.summary$.value.successesCount + 1
      });
    } else if (action.statusCode === ProductImportStatus.LOW_STOCK) {
      this.summary$.next({
        ...this.summary$.value,
        count: this.summary$.value.count + 1,
        warningMessages: [...this.summary$.value.warningMessages, action]
      });
    } else {
      this.summary$.next({
        ...this.summary$.value,
        count: this.summary$.value.count + 1,
        errorMessages: [...this.summary$.value.errorMessages, action]
      });
    }
  }
  static {
    this.ɵfac = function ImportEntriesDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportEntriesDialogComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImportEntriesDialogComponent,
      selectors: [["cx-import-entries-dialog"]],
      standalone: false,
      decls: 14,
      vars: 16,
      consts: [["importSummary", ""], ["reducedForm", ""], ["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "cx-import-entries-dialog", 3, "esc", "cxFocus"], [1, "modal-content", "cx-import-entries-container"], [1, "modal-header", "cx-import-entries-header"], ["id", "dialogTitle", "class", "cx-import-entries-title modal-title", 4, "cxFeature"], ["type", "button", 1, "cx-import-entries-close", "close", 3, "click", "title", "disabled"], ["aria-hidden", "true"], [3, "type"], [4, "ngIf"], ["id", "dialogTitle", 1, "cx-import-entries-title", "modal-title"], [4, "ngIf", "ngIfElse"], ["class", "modal-body", 3, "type", "submitEvent", 4, "ngIf", "ngIfElse"], [1, "modal-body", 3, "submitEvent", "type"], [1, "modal-body", 3, "closeEvent", "summary", "type"]],
      template: function ImportEntriesDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵlistener("esc", function ImportEntriesDialogComponent_Template_div_esc_0_listener() {
            return ctx.close("Escape clicked");
          });
          i0.ɵɵelementStart(1, "div", 3)(2, "div", 4);
          i0.ɵɵelementContainerStart(3);
          i0.ɵɵtemplate(4, ImportEntriesDialogComponent_h3_4_Template, 3, 3, "h3", 5)(5, ImportEntriesDialogComponent_div_5_Template, 3, 3, "div", 5);
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementStart(6, "button", 6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵpipe(8, "async");
          i0.ɵɵpipe(9, "cxTranslate");
          i0.ɵɵlistener("click", function ImportEntriesDialogComponent_Template_button_click_6_listener() {
            return ctx.close("Close Import Products Dialog");
          });
          i0.ɵɵelementStart(10, "span", 7);
          i0.ɵɵelement(11, "cx-icon", 8);
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(12, ImportEntriesDialogComponent_ng_container_12_Template, 4, 2, "ng-container", 9);
          i0.ɵɵpipe(13, "async");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          let tmp_4_0;
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 8, "importEntriesDialog.close"));
          i0.ɵɵproperty("disabled", (tmp_4_0 = i0.ɵɵpipeBind1(8, 10, ctx.summary$)) == null ? null : tmp_4_0.loading);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 12, "importEntriesDialog.close"));
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("type", ctx.iconTypes.CLOSE);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 14, ctx.context$));
        }
      },
      dependencies: [i1$1.NgIf, i1.IconComponent, i1.FocusDirective, i3$1.FeatureDirective, ImportEntriesFormComponent, ImportEntriesSummaryComponent, ImportToNewSavedCartFormComponent, i1$1.AsyncPipe, i3$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportEntriesDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-import-entries-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  class=\"modal-dialog modal-dialog-centered cx-import-entries-dialog\"\n  role=\"dialog\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content cx-import-entries-container\">\n    <!-- Modal Header -->\n    <div class=\"modal-header cx-import-entries-header\">\n      <ng-container>\n        <h3\n          *cxFeature=\"'a11yDialogsHeading'\"\n          id=\"dialogTitle\"\n          class=\"cx-import-entries-title modal-title\"\n        >\n          {{ 'importEntriesDialog.importProducts' | cxTranslate }}\n        </h3>\n        <div\n          *cxFeature=\"'!a11yDialogsHeading'\"\n          id=\"dialogTitle\"\n          class=\"cx-import-entries-title modal-title\"\n        >\n          {{ 'importEntriesDialog.importProducts' | cxTranslate }}\n        </div>\n      </ng-container>\n\n      <button\n        (click)=\"close('Close Import Products Dialog')\"\n        [attr.aria-label]=\"'importEntriesDialog.close' | cxTranslate\"\n        title=\"{{ 'importEntriesDialog.close' | cxTranslate }}\"\n        class=\"cx-import-entries-close close\"\n        type=\"button\"\n        [disabled]=\"(summary$ | async)?.loading\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n\n    <!-- Modal Body -->\n    <ng-container *ngIf=\"context$ | async as context\">\n      <ng-container *ngIf=\"formState; else importSummary\">\n        <cx-import-to-new-saved-cart-form\n          class=\"modal-body\"\n          *ngIf=\"isNewCartForm(context); else reducedForm\"\n          [type]=\"context.type\"\n          (submitEvent)=\"importProducts(context, $event)\"\n        ></cx-import-to-new-saved-cart-form>\n        <ng-template #reducedForm>\n          <cx-import-entries-form\n            class=\"modal-body\"\n            [type]=\"context.type\"\n            (submitEvent)=\"importProducts(context, $event)\"\n          ></cx-import-entries-form>\n        </ng-template>\n      </ng-container>\n\n      <ng-template #importSummary>\n        <cx-import-entries-summary\n          class=\"modal-body\"\n          [summary]=\"summary$ | async\"\n          [type]=\"context.type\"\n          (closeEvent)=\"close('Close Import Products Dialog')\"\n        ></cx-import-entries-summary>\n      </ng-template>\n    </ng-container>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultImportEntriesLayoutConfig = {
  launch: {
    IMPORT_TO_CART: {
      inlineRoot: true,
      component: ImportEntriesDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportOrderEntriesModule {
  static {
    this.ɵfac = function ImportOrderEntriesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportOrderEntriesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ImportOrderEntriesModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultImportEntriesLayoutConfig)],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FormErrorsModule, IconModule, KeyboardFocusModule, FileUploadModule, I18nModule, MessageComponentModule, FeaturesConfigModule, ConfigModule.withConfig({
        cmsComponents: {
          ImportOrderEntriesComponent: {
            component: ImportOrderEntriesComponent
          }
        }
      }), FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportOrderEntriesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FormErrorsModule, IconModule, KeyboardFocusModule, FileUploadModule, I18nModule, MessageComponentModule, FeaturesConfigModule, ConfigModule.withConfig({
        cmsComponents: {
          ImportOrderEntriesComponent: {
            component: ImportOrderEntriesComponent
          }
        }
      }), FeaturesConfigModule],
      declarations: [ImportOrderEntriesComponent, ImportEntriesDialogComponent, ImportEntriesFormComponent, ImportEntriesSummaryComponent, ImportToNewSavedCartFormComponent],
      exports: [ImportOrderEntriesComponent, ImportEntriesDialogComponent, ImportEntriesFormComponent, ImportEntriesSummaryComponent, ImportToNewSavedCartFormComponent],
      providers: [provideDefaultConfig(defaultImportEntriesLayoutConfig)]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportExportOrderEntriesComponent {
  constructor(contextService) {
    this.contextService = contextService;
    this.context$ = this.contextService.get(ORDER_ENTRIES_CONTEXT);
    this.shouldDisplayImport$ = this.context$.pipe(map(orderEntriesContext => !!orderEntriesContext?.addEntries));
    this.shouldDisplayExport$ = this.context$.pipe(switchMap(orderEntriesContext => orderEntriesContext?.getEntries?.() ?? of([])), map(entries => !!entries?.length));
  }
  static {
    this.ɵfac = function ImportExportOrderEntriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportExportOrderEntriesComponent)(i0.ɵɵdirectiveInject(i1.ContextService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImportExportOrderEntriesComponent,
      selectors: [["cx-import-export-order-entries"]],
      standalone: false,
      decls: 4,
      vars: 6,
      consts: [[4, "ngIf"]],
      template: function ImportExportOrderEntriesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ImportExportOrderEntriesComponent_cx_import_order_entries_0_Template, 1, 0, "cx-import-order-entries", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, ImportExportOrderEntriesComponent_cx_export_order_entries_2_Template, 1, 0, "cx-export-order-entries", 0);
          i0.ɵɵpipe(3, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.shouldDisplayImport$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.shouldDisplayExport$));
        }
      },
      dependencies: [ImportOrderEntriesComponent, ExportOrderEntriesComponent, i1$1.NgIf, i1$1.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportExportOrderEntriesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-import-export-order-entries',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-import-order-entries\n  *ngIf=\"shouldDisplayImport$ | async\"\n></cx-import-order-entries>\n<cx-export-order-entries\n  *ngIf=\"shouldDisplayExport$ | async\"\n></cx-export-order-entries>\n"
    }]
  }], () => [{
    type: i1.ContextService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportExportOrderEntriesModule {
  static {
    this.ɵfac = function ImportExportOrderEntriesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportExportOrderEntriesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ImportExportOrderEntriesModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [PageComponentModule, ConfigModule.withConfig({
        cmsComponents: {
          ImportExportOrderEntriesComponent: {
            component: ImportExportOrderEntriesComponent
          }
        }
      }), I18nModule, UrlModule, ImportOrderEntriesModule, ExportOrderEntriesModule, CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportExportOrderEntriesModule, [{
    type: NgModule,
    args: [{
      imports: [PageComponentModule, ConfigModule.withConfig({
        cmsComponents: {
          ImportExportOrderEntriesComponent: {
            component: ImportExportOrderEntriesComponent
          }
        }
      }), I18nModule, UrlModule, ImportOrderEntriesModule, ExportOrderEntriesModule, CommonModule],
      exports: [ImportExportOrderEntriesComponent],
      declarations: [ImportExportOrderEntriesComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ExportOrderEntriesComponent, ExportOrderEntriesModule, ExportOrderEntriesToCsvService, ImportEntriesDialogComponent, ImportEntriesFormComponent, ImportEntriesSummaryComponent, ImportExportOrderEntriesComponent, ImportExportOrderEntriesModule, ImportOrderEntriesComponent, ImportOrderEntriesModule, ImportProductsFromCsvService, ImportToNewSavedCartFormComponent };
